import React, { useState } from 'react';

export default function WelcomeModal({ user, showAuth, setPage }) {
  const [dismissed, setDismissed] = useState(
    () => !!localStorage.getItem('paydirt_welcome_dismissed')
  );
  const [agreed, setAgreed] = useState(false);

  if (user || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem('paydirt_welcome_dismissed', 'true');
    setDismissed(true);
  };

  return (
    <>
      {/* Partial overlay — covers below the news feed, leaves cards visible */}
      <div
        onClick={dismiss}
        style={{
          position: 'fixed', top: 520, left: 0, right: 0, bottom: 0, zIndex: 249,
          background: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
        }}
      />

      {/* Modal card — fixed center */}
      <div
        style={{
          position: 'fixed', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)', zIndex: 250,
          background: '#111', border: '1px solid #1f2937', borderRadius: 14,
          width: 'calc(100% - 32px)', maxWidth: 420, padding: '32px 28px 28px',
          maxHeight: '90vh', overflowY: 'auto',
          boxShadow: '0 24px 80px rgba(0, 0, 0, 0.8)',
        }}
      >
        {/* Close */}
        <button
          onClick={dismiss}
          style={{
            position: 'absolute', top: 14, right: 16, background: 'none',
            border: 'none', color: '#666', fontSize: 18, cursor: 'pointer',
          }}
        >&times;</button>

        {/* Logo lockup */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'Dela Gothic One', cursive", fontSize: 28, color: '#00e676' }}>$</span>
            <span style={{ fontFamily: "'Dela Gothic One', cursive", fontSize: 22, color: '#fff', letterSpacing: '0.04em' }}>
              PAYDIRT<span style={{ color: '#00e676', fontSize: 12, marginLeft: 4, verticalAlign: 'super' }}>NEWS</span>
            </span>
          </div>
          <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 8, color: '#666', letterSpacing: '0.2em', textTransform: 'uppercase', marginTop: 4 }}>
            INVEST IN THE TRUTH
          </div>
        </div>

        {/* Heading */}
        <h2 style={{
          fontFamily: "'Dela Gothic One', cursive", fontWeight: 900,
          fontSize: 20, color: '#fff', textAlign: 'center', lineHeight: 1.3,
          marginBottom: 8,
        }}>
          Bet on Credibility and Win Real Prizes
        </h2>

        <p style={{
          color: '#9ca3af', fontSize: 13, textAlign: 'center',
          lineHeight: 1.6, marginBottom: 22, fontFamily: "'DM Sans', sans-serif",
        }}>
          Use virtual credits to predict media credibility. No real money needed and real rewards up for grabs.
        </p>

        {/* Prizes card */}
        <div style={{
          background: '#0a0a0a', border: '1px solid #1f2937', borderRadius: 10,
          padding: '16px 18px', marginBottom: 20,
        }}>
          <div style={{
            fontFamily: 'JetBrains Mono, monospace', fontSize: 9,
            color: '#666', letterSpacing: '0.1em', textTransform: 'uppercase',
            marginBottom: 14,
          }}>
            WEEKLY AND MONTHLY WINNERS RECEIVE
          </div>

          {[
            { emoji: '\uD83D\uDCDA', title: '2-Year Perlego Subscription', desc: 'Over 1 million titles, worth nearly $300', faded: false },
            { emoji: '\uD83D\uDCB5', title: 'Cash prizes beginning at $500/month', desc: 'Paid out monthly to top performers', faded: false },
            { emoji: '\u2728', title: 'More rewards coming soon', desc: 'As the community grows', faded: true },
          ].map((r, i) => (
            <div key={i}>
              {i > 0 && <div style={{ height: 1, background: '#1f2937', margin: '10px 0' }} />}
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', opacity: r.faded ? 0.5 : 1 }}>
                <span style={{ fontSize: 20, flexShrink: 0, lineHeight: 1 }}>{r.emoji}</span>
                <div>
                  <div style={{ color: r.faded ? '#9ca3af' : '#00e676', fontWeight: 700, fontSize: 13 }}>{r.title}</div>
                  <div style={{ color: '#6b7280', fontSize: 11, marginTop: 2 }}>{r.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pulsing dot disclaimer */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, justifyContent: 'center' }}>
          <span style={{
            width: 6, height: 6, borderRadius: '50%', background: '#00e676',
            display: 'inline-block', animation: 'pulse 2s ease-in-out infinite',
          }} />
          <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 10, color: '#6b7280' }}>
            100% virtual credits, no real money needed to play
          </span>
        </div>

        {/* T&C checkbox */}
        <label style={{
          display: 'flex', gap: 10, alignItems: 'flex-start',
          marginBottom: 20, cursor: 'pointer', userSelect: 'none',
        }}>
          <input
            type="checkbox"
            checked={agreed}
            onChange={e => setAgreed(e.target.checked)}
            style={{ marginTop: 3, accentColor: '#00e676', flexShrink: 0 }}
          />
          <span style={{ color: '#9ca3af', fontSize: 11, lineHeight: 1.5 }}>
            I agree to the{' '}
            <span
              onClick={e => { e.preventDefault(); dismiss(); setPage('terms'); }}
              style={{ color: '#00e676', textDecoration: 'underline', cursor: 'pointer' }}
            >Terms and Conditions</span>
            {' '}and confirm prizes are subject to eligibility criteria.
          </span>
        </label>

        {/* Buttons */}
        <button
          disabled={!agreed}
          onClick={() => { dismiss(); showAuth(); }}
          style={{
            width: '100%', padding: '12px 0', border: 'none', borderRadius: 8,
            fontWeight: 800, fontSize: 14, letterSpacing: '0.04em', cursor: agreed ? 'pointer' : 'default',
            fontFamily: "'DM Sans', sans-serif",
            background: agreed ? 'linear-gradient(135deg, #00e676, #00c853)' : '#1f2937',
            color: agreed ? '#000' : '#555',
            transition: 'all 0.2s',
          }}
        >
          REGISTER NOW
        </button>

        <button
          onClick={dismiss}
          style={{
            width: '100%', padding: '10px 0', marginTop: 10,
            background: 'none', border: '1px solid #333', borderRadius: 8,
            color: '#9ca3af', fontSize: 13, cursor: 'pointer',
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Browse first &rarr;
        </button>
      </div>
    </>
  );
}
